import {
  CHECK_HEALTH,
  CHECK_HEALTH_SUCCESS,
  CHECK_HEALTH_ERROR,
  GET_CHATS,
  GET_CHATS_SUCCESS,
  GET_CHATS_ERROR,
  SEND_CHAT_MESSAGE,
  SEND_CHAT_MESSAGE_SUCCESS,
  SEND_CHAT_MESSAGE_ERROR,
  GET_CHAT_MESSAGES,
  GET_CHAT_MESSAGES_SUCCESS,
  GET_CHAT_MESSAGES_ERROR,
  UPLOAD_CHAT_ATTACHMENT,
  UPLOAD_CHAT_ATTACHMENT_SUCCESS,
  UPLOAD_CHAT_ATTACHMENT_ERROR,
  DELETE_CHAT_ATTACHMENT,
  DELETE_CHAT_ATTACHMENT_SUCCESS,
  DELETE_CHAT_ATTACHMENT_ERROR,
  UPDATE_CHAT_MESSAGE,
  UPDATE_CHAT_MESSAGE_SUCCESS,
  UPDATE_CHAT_MESSAGE_ERROR,
  CHECK_ATTACHMENT_STATUS,
  CHECK_ATTACHMENT_STATUS_SUCCESS,
  CHECK_ATTACHMENT_STATUS_ERROR,
  CHAT_DRAWER_OPEN_SUCCESS,
  SET_CHAT_ID,
  FINAL_TOOL,
  FINAL_TOOL_SUCCESS,
  FINAL_TOOL_ERROR,
  LLM_SET_CHAT_CONTENT,
  GET_TRANSLATED_CONTENT,
  GET_TRANSLATED_CONTENT_SUCCESS,
  GET_TRANSLATED_CONTENT_ERROR,
} from './type'

/**
 *
 *@param {*} callback
 */
export const llmCheckHealthAction = callback => {
  return {
    type: CHECK_HEALTH,
    payload: { callback },
  }
}

/**
 *
 * @param {*} response
 */
export const llmCheckHealthSuccess = response => {
  return {
    type: CHECK_HEALTH_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const llmCheckHealthError = () => {
  return {
    type: CHECK_HEALTH_ERROR,
  }
}

/**
 *
 * @param {*} callback
 */
export const llmGetChatsAction = callback => {
  return {
    type: GET_CHATS,
    payload: { callback },
  }
}

/**
 *
 * @param {*} response
 */
export const llmGetChatsSuccess = response => {
  return {
    type: GET_CHATS_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const llmGetChatsError = () => {
  return {
    type: GET_CHATS_ERROR,
  }
}

/**
 *
 * @param {*} chatData
 * @param {*} callback
 */
export const llmSendChatMessageAction = (chatData, callback) => {
  return {
    type: SEND_CHAT_MESSAGE,
    payload: { chatData, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const llmSendChatMessageSuccess = response => {
  return {
    type: SEND_CHAT_MESSAGE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const llmSendChatMessageError = () => {
  return {
    type: SEND_CHAT_MESSAGE_ERROR,
  }
}

/**
 *
 * @param {*} callback
 * @param {*} chatId
 */
export const llmGetChatMessagesAction = (chatId, callback) => {
  return {
    type: GET_CHAT_MESSAGES,
    payload: { chatId, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const llmGetChatMessagesSuccess = response => {
  return {
    type: GET_CHAT_MESSAGES_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const llmGetChatMessagesError = () => {
  return {
    type: GET_CHAT_MESSAGES_ERROR,
  }
}

/**
 *
 * @param {*} formData
 * @param {*} fileName
 * @param {*} callback
 */

export const llmUploadAttachmentAction = (formData, fileName, callback) => {
  return {
    type: UPLOAD_CHAT_ATTACHMENT,
    payload: { formData, fileName, callback },
  }
}

/**
 *
 * @param {*} response
 * @param {*} fileName
 */
export const llmUploadAttachmentSuccess = (response, fileName) => {
  return {
    type: UPLOAD_CHAT_ATTACHMENT_SUCCESS,
    payload: { response, fileName },
  }
}

/**
 *
 */

export const llmUploadAttachmentError = () => {
  return {
    type: UPLOAD_CHAT_ATTACHMENT_ERROR,
  }
}

/**
 *
 * @param {*} chatId
 * @param {*} attachmentId
 * @param {*} callback
 */

export const llmDeleteAttachmentAction = (chatId, attachmentId, callback) => {
  return {
    type: DELETE_CHAT_ATTACHMENT,
    payload: { chatId, attachmentId, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const llmDeleteAttachmentSuccess = response => {
  return {
    type: DELETE_CHAT_ATTACHMENT_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */

export const llmDeleteAttachmentError = () => {
  return {
    type: DELETE_CHAT_ATTACHMENT_ERROR,
  }
}

/**
 *
 * @param {*} outline
 * @param {*} chatId
 * @param {*} callback
 *
 */
export const llmUpdateChatMessageAction = (chatId, outline, callback) => {
  return {
    type: UPDATE_CHAT_MESSAGE,
    payload: { chatId, outline, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const llmUpdateChatMessageSuccess = response => {
  return {
    type: UPDATE_CHAT_MESSAGE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const llmUpdateChatMessageError = () => {
  return {
    type: UPDATE_CHAT_MESSAGE_ERROR,
  }
}

/**
 *
 * @param {*} chatId
 * @param {*} attachmentId
 * @param {*} callback
 *
 */
export const llmCheckAttachmentStatusAction = (
  chatId,
  attachmentId,
  callback,
) => {
  return {
    type: CHECK_ATTACHMENT_STATUS,
    payload: { chatId, attachmentId, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const llmCheckAttachmentStatusSuccess = response => {
  return {
    type: CHECK_ATTACHMENT_STATUS_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const llmCheckAttachmentStatusError = () => {
  return {
    type: CHECK_ATTACHMENT_STATUS_ERROR,
  }
}

/**
 *
 */
export const llmChatDrawerOpen = () => {
  return {
    type: CHAT_DRAWER_OPEN_SUCCESS,
  }
}

/**
 *
 * @param {*} chatId
 */
export const llmSetChatId = chatId => {
  return {
    type: SET_CHAT_ID,
    payload: { chatId },
  }
}

/**
 *
 * @param {*} courseId
 * @param {*} languageCode
 * @param {*} callback
 */
export const llmFinalToolAction = (
  courseId,
  languageCode,
  chatId,
  isMobile,
  courseCode,
  callback,
) => {
  return {
    type: FINAL_TOOL,
    payload: { courseId, languageCode, chatId, isMobile, courseCode, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const llmFinalToolSuccess = response => {
  return {
    type: FINAL_TOOL_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const llmFinalToolError = () => {
  return {
    type: FINAL_TOOL_ERROR,
  }
}

export const llmSetChatContent = () => {
  return {
    type: LLM_SET_CHAT_CONTENT,
  }
}

/**
 *
 * @param {*} content
 * @param {*} languageCode
 * @param {*} courseType
 * @param {*} callback
 */
export const llmGetTranslatedContentAction = (
  content,
  languageCode,
  courseType,
  callback,
) => {
  return {
    type: GET_TRANSLATED_CONTENT,
    payload: { content, languageCode, courseType, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const llmGetTranslatedContentSuccess = response => {
  return {
    type: GET_TRANSLATED_CONTENT_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const llmGetTranslatedContentError = () => {
  return {
    type: GET_TRANSLATED_CONTENT_ERROR,
  }
}
